export class BFFGatewayConfiguration {
    constructor(param) {
        this.accessToken = param.accessToken;
        this.locale = param.locale;
        this.basePath = param.basePath;
        this.blockId = param.blockId;
    }
}
//# sourceMappingURL=BFFGatewayConfiguration.js.map